import type { SchemaDefinition } from '../types/localDb.types'
import { PLATFORM_SCHEMA } from './platform.schema'
import { WMS_SCHEMA } from './wms.schema'

export const LOCAL_DB_SCHEMA: SchemaDefinition = { ...PLATFORM_SCHEMA, ...WMS_SCHEMA }
